import React, { Fragment, useState } from 'react'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTools } from '@fortawesome/pro-solid-svg-icons/faTools'
import Button from 'pobble-components/dist/button'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Controls from './controls/controls'
import { withMe } from 'pobble-components/dist/pobble-user'

const styles = ({ COLORS }) => ({
  button: {
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'inline-flex'
    }
  }
})

const PresentationControls = ({
  classes,
  me,
  meRequest,
  presentation,
  style,
  ...props
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  if (!me || !me.account.policy.can_set_presentation_recommended_until)
    return null
  return (
    <Fragment>
      <Button
        simple
        className={classes.button}
        icon={<FontAwesomeIcon icon={faTools} />}
        action={() => setModalOpen(true)}
        style={style}
        tall>
        Admin
      </Button>
      {!!presentation && (
        <Modal
          isOpen={modalOpen}
          closeButton
          requestClose={() => setModalOpen(false)}>
          <ModalHeader>Admin presentation tools</ModalHeader>
          <ModalContent legacy>
            <Controls presentation={presentation} {...props} />
          </ModalContent>
          <ModalFooter alignRight>
            <Button tall simple action={() => setModalOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  )
}

export default withMe(injectSheet(styles)(PresentationControls))
